import * as React from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { CheckIcon } from 'lucide-react';
import { cn } from '../../utils/cn';

export function SelectItem({
    className,
    children,
    hideIndicator = false,
    ...props
}: React.ComponentProps<typeof SelectPrimitive.Item> & {
    hideIndicator?: boolean;
}) {
    return (
        <SelectPrimitive.Item
            data-slot="select-item"
            className={cn(
                'relative flex w-full cursor-default select-none items-center gap-2 rounded-sm py-1.5 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 last:[&>span]:flex last:[&>span]:items-center last:[&>span]:gap-2 [&_svg:not([class*="size-"])]:size-4 [&_svg:not([class*="text-"])]:text-muted-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0',
                hideIndicator ? 'pl-2' : 'pl-8',
                className,
            )}
            {...props}
        >
            {!hideIndicator && (
                <span className="absolute left-2 flex size-3.5 items-center justify-center">
                    <SelectPrimitive.ItemIndicator>
                        <CheckIcon className="size-4" />
                    </SelectPrimitive.ItemIndicator>
                </span>
            )}
            <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
        </SelectPrimitive.Item>
    );
}
